import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { ApiService } from "../services";

// eslint-disable-next-line import/prefer-default-export
export const useGetAddresses = () => {
  const user = useSelector((state) => state.user);
  return useQuery({
    queryKey: ["addresses", user?.authToken],
    queryFn: async () => {
      const response = await ApiService.get("me/addresses", {
        authorization: `Bearer ${user.authToken}`
      });

      return response;
    },
    staleTime: Infinity,
    enabled: !!user?.authToken
  });
};
